<template>
  <div>
    <Header/>
    <div class="zwB "></div>
    <div class="bodyBG2">
      <div class="curBoxb">
       <BreadCrumb/>
      </div>
      <div class="zcglBa"></div>
      <div class="listPBa">
        <CompanyIntroductionsLeftNav/>
        <div class="listPBr">
          <div class="docTitleB">
            <h1>
              {{$t('contact_us')}}
            </h1>
            <div class="timeB">
              {{$t('belonging_to')}} {{$t('company_introductions')}} {{$t('author')}} {{$t('tajik_securities')}} {{$t('update_time')}}：2020-06-03 14:03:36
            </div>
          </div>
          <div class="connectionTable">
            <table cellpadding="0" cellspacing="0">
              <tr class="tableOdd">
                <td>{{$t('address')}}</td>
                <td>
                  {{$t('address_one')}}<br/>
                  {{$t('address_two')}}
                </td>
              </tr>
              <tr class="tableEven">
                <td>{{$t('internet_address')}}</td>
                <td>www.sctajik.com</td>
              </tr>
              <tr class="tableOdd">
                  <td>{{$t('email')}}</td>
                  <td>info@caiis-tj.com </td>
              </tr>
              <tr class="tableEven">
                  <td>{{$t('switchboard')}}</td>
                  <td>+992372273502</td>
              </tr>
              <tr class="tableOdd">
                <td>{{$t('company_fax')}}</td>
                <td> </td>
              </tr>
            </table>
          </div>
        </div>
      </div>
    </div>
    <Footer/>
  </div>
</template>
<script>
  import Footer from "../components/Footer";
  import Header from "../components/Header";
  import CompanyIntroductionsLeftNav from "../components/CompanyIntroductionsLeftNav";
  import BreadCrumb from "../components/BreadCrumb";

  export default {
    components: {BreadCrumb, CompanyIntroductionsLeftNav, Footer, Header}
  }
</script>
<style lang="scss" scoped>
@import url('../css/2020_swiper.min.css');
@import url('../css/public_20200313v4.css');
@import url('../css/index.css');
@import url('../css/public_footer.css');
@import url('../css/zxStyle.css');
@import url('../css/zxPubliceStyle.css');
@import url('../css/shzr_zr2020.css');
</style>
<style>
    .zwB {
        height: 130px;
    }
</style>